document.addEventListener('DOMContentLoaded', function () {

    const header = document.getElementById('PremiumHeader');
    const menu = document.getElementById('PremiumMobileMenu');

    const openButton = document.querySelector('.premium-header__toggle');
    const closeButton = document.querySelector('.premium-mobile-menu__close');
    if (menu && document.body) {
        document.body.appendChild(menu);
    }

    if (!header) return;

    /* ======================================
       Sticky Header
    ====================================== */

    function updateHeader() {

        if (window.scrollY > 40) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }

    }

    updateHeader();

    window.addEventListener('scroll', updateHeader);

    /* ======================================
       Mobile Menu
    ====================================== */

    function openMenu() {

        if (!menu) return;

        menu.hidden = false;

        requestAnimationFrame(function () {

            menu.classList.add('is-open');

        });

        document.documentElement.classList.add('menu-open');
        document.body.classList.add('menu-open');

        if (openButton) {
            openButton.setAttribute('aria-expanded', 'true');
        }

    }

    function closeMenu() {

        if (!menu) return;

        menu.classList.remove('is-open');

        document.documentElement.classList.remove('menu-open');
        document.body.classList.remove('menu-open');

        if (openButton) {
            openButton.setAttribute('aria-expanded', 'false');
        }

        setTimeout(function () {

            menu.hidden = true;

        }, 350);

    }

    if (openButton) {

        openButton.addEventListener('click', function () {

            openMenu();

        });

    }

    if (closeButton) {

        closeButton.addEventListener('click', function () {

            closeMenu();

        });

    }

    /* ======================================
       Close on Escape
    ====================================== */

    document.addEventListener('keydown', function (event) {

        if (event.key === 'Escape') {

            closeMenu();

        }

    });

    /* ======================================
       Close on Navigation Click
    ====================================== */

    document.querySelectorAll('.premium-mobile-menu a').forEach(function (link) {

        link.addEventListener('click', function () {

            closeMenu();

        });

    });

    /* ======================================
       Close when clicking outside menu
    ====================================== */

    menu.addEventListener('click', function (event) {

        if (event.target === menu) {

            closeMenu();

        }

    });

});